import { getBuyerId } from 'dibs-cookie-jar';
import { fetchQuery, graphql } from 'react-relay';
import get from 'lodash.get';

import { canShowTradePromoModal, markExpiringModalSeen, isAtViewLimit } from './tradePromoHelpers';
import { TRADE_PROMO_CODES as promoCodes } from './constants';

const query = graphql`
    query expiringTradePromoRule_Query($userId: String!, $promoCodes: [String]) {
        viewer {
            user(userId: $userId) {
                expiringPromotion(promoCodes: $promoCodes, daysToExpiration: 14) {
                    code
                }
                tradeFirmRewards {
                    expiringPromoSegment {
                        expiringSegmentCode
                    }
                }
            }
        }
    }
`;

function queryExpiringTradePromo(relayEnvironment) {
    const userId = getBuyerId(document.cookie);
    return fetchQuery(relayEnvironment, query, { userId, promoCodes }).then(data => {
        const expiringPromoCode = get(data, 'viewer.user.expiringPromotion.code');
        const expiringSegmentCode = get(
            data,
            'viewer.user.tradeFirmRewards.expiringPromoSegment.expiringSegmentCode'
        );
        if (expiringSegmentCode && !isAtViewLimit(expiringSegmentCode)) {
            markExpiringModalSeen(expiringSegmentCode);
            return true;
        } else if (expiringPromoCode && !isAtViewLimit(expiringPromoCode)) {
            markExpiringModalSeen(expiringPromoCode);
            return true;
        }

        return false;
    });
}

export function expiringTradePromoRule({ relayEnvironment }) {
    if (canShowTradePromoModal()) {
        return queryExpiringTradePromo(relayEnvironment);
    }

    return Promise.resolve(false);
}
